module.exports = __webpack_public_path__ + "static/media/alert-red-simple.77f83187.svg";